import { Component, OnDestroy } from '@angular/core';
import { AuthService } from "../../services/auth.service";
import { LoginRequired } from "../../decorators/login.required";
import { PageTitleService } from "../../services/page-title.service";
import { IonicHelper } from "../../helpers/ionic.helper";
import { ApiCollectionResponse, ApiViewData, Category, Report, Tag, Feedback, User, UserGroup, ViewDidEnter, UserInvite } from '../../app/app.interfaces';
import { NavController, NavParams } from "ionic-angular";
import { FormBuilder } from "@angular/forms";
import { ApiService } from "../../services/api.service";
import { UserGroupService } from "../../services/user-group.service";
import { CategoryService } from '../../services/category.service';
import { TagService } from '../../services/tag.service';


@Component({
  selector: 'admin-panel',
	templateUrl: 'admin-panel.html'
})

@LoginRequired(true)

export class AdminPanel implements ViewDidEnter, OnDestroy {

	template: string = 'gebruikers';

	users: User[] = [];
	reports: Report[] = [];
	userSearchTerm: string = null;
	userView: ApiViewData = {};
	reportsView: ApiViewData = {};
	feedbackView: ApiViewData = {};
	userInvitesView: ApiViewData = {};

	userGroups: UserGroup[] = [];
	categories: Category[] = [];
	tags: Tag[] = [];
	feedback: Feedback[] = [];
	allUserInvites: UserInvite[] = [];
	visibleUserInvites: UserInvite[] = [];
	userInviteSearchTerm: string = null;

	constructor(private formBuilder: FormBuilder,
							public authService: AuthService,
							private apiService: ApiService,
							private nav: NavController,
							private navParams: NavParams,
							private ionic: IonicHelper,
							private pageTitleService: PageTitleService,
							public userGroupService: UserGroupService,
							private categoryService: CategoryService,
							private tagService: TagService) {
	}

	ngOnDestroy(): void {
	  this.userGroupService.loadUserGroups();
  }

	ionViewDidEnter(): void {

		this.pageTitleService.setPageTitle('admin-panel');


		let routedNav = this.navParams.get('template');

		this.updateTemplate(routedNav);

	}

	updateTemplate(template:string = 'gebruikers'): void{
		this.template = template;

		switch(this.template){
      case "gebruikers":
			  this.loadUsers();
		    break;
      case "groepen":
			  this.loadUserGroups();
        break;
			case "categorieen":
				this.loadCategories();
        break;
      case "gerapporteerd":
			  this.loadReports();
        break;
			case "tags":
			  this.loadTags();
        break;
      case "feedback":
			  this.loadFeedback();
        break;
      case "uitnodigingen":
			  this.loadUserInvites();
        break;
    }
	}

	usersLoadMore(): void{
		this.loadUsers(this.userView.pages.next, null, true);
	}
	reportsLoadMore(): void{
		this.loadReports(this.reportsView.pages.next, null, true);
	}
	feedbackLoadMore(): void{
		this.loadFeedback(this.feedbackView.pages.next, null, true);
	}
	userInvitesLoadMore(): void{
		this.loadUserInvites(this.userInvitesView.pages.next, null, true);
	}


	userSearch(): void{
		if(this.userSearchTerm) {
				this.users = [];
				this.loadUsers('users', { fullName: this.userSearchTerm }, false);
		}
		else {
      	this.loadUsers('users', null, false);
    }
	}

	loadUserGroups(){
	  this.userGroupService.allAsync().then((userGroups) => {
	      this.userGroups = userGroups;
    });
  }

  addUserGroup(newUserGroup: UserGroup) {
	  this.userGroups.push(newUserGroup);
  }

  removeUserGroup(userGroup: UserGroup){
    this.userGroups = this.userGroups.filter(e => e !== userGroup);
  }

	loadUsers(uri: string = 'users', filters: any = null, append: boolean = false): void {

		this.userView.loading = true;

		this.apiService.getCollection(uri, filters).then((apiResponse: ApiCollectionResponse) => {

			if(append) {
				this.users = [...this.users, ...apiResponse.items];
			}
			else {
				this.users = apiResponse.items
			}

			this.userView.loading = false;
			this.userView = apiResponse.view;

		}).catch((err) => {
			console.error(err);
			this.ionic.alert('GLOBAL.GENERAL_ERROR');
		});
	}

	loadCategories(){
		this.categoryService.getAllCategories().then((categories) => {
			this.categories = categories;
		});
	}

	addCategory(newCategory: Category) {
		this.categories.push(newCategory);
	}

	removeCategory(category: Category) {
		this.categories = this.categories.filter(e => e !== category);
	}

	loadTags() {
		this.tagService.getAllTags().then((tags) => {
			this.tags = tags;
		});
	}

	removeTag(tag: Tag) {
		this.tags = this.tags.filter(e => e !== tag);
	}


	loadReports(uri: string = 'reports', filters: any = null, append: boolean = false): void {

    this.reportsView.loading = true;

    this.apiService.getCollection(uri, filters).then((apiResponse: ApiCollectionResponse) => {
      if(append) {
        this.reports = [...this.reports, ...apiResponse.items];
      }
      else {
        this.reports = apiResponse.items
      }

      // console.log(this.reports);

      this.reportsView = apiResponse.view;
      this.reportsView.loading = false;

    }).catch((err) => {
      console.error(err);
      this.ionic.alert('GLOBAL.GENERAL_ERROR');
    });

	}

	removeReport(report: Report){

    this.ionic.confirm('REPORT.CONFIRM_DELETE_MSG', 'GLOBAL.ARE_YOU_SURE','GLOBAL.DELETE').subscribe((confirmed: boolean) => {
      if(confirmed){
        this.apiService.deleteResource(report).then(()=>{
          this.ionic.toast('REPORT.DELETED_TOAST');
          this.reports = this.reports.filter(e => e !== report);
        }).catch((err) => {
					console.error(err);
					this.ionic.alert('GLOBAL.GENERAL_ERROR');
				});
      }
    })


  }

  loadFeedback(uri: string = 'feedback', filters: any = null, append: boolean = false): void {
    this.feedbackView.loading = true;

    this.apiService.getCollection(uri, filters).then((apiResponse: ApiCollectionResponse) => {
      if(append) {
        this.feedback = [...this.feedback, ...apiResponse.items];
      }
      else {
        this.feedback = apiResponse.items;
      }

      this.feedbackView = apiResponse.view;
      this.feedbackView.loading = false;

    }).catch((err) => {
      console.error(err);
      this.ionic.alert('GLOBAL.GENERAL_ERROR');
    });

  }

  removeFeedback(feedback: Feedback){
    this.ionic.confirm('FEEDBACK.CONFIRM_DELETE_MSG', 'GLOBAL.ARE_YOU_SURE','GLOBAL.DELETE').subscribe((confirmed: boolean) => {
      if(confirmed){
        this.apiService.deleteResource(feedback).then(()=>{
          this.ionic.toast('FEEDBACK.DELETED_TOAST');
          this.feedback = this.feedback.filter(e => e !== feedback);
        }).catch((err) => {
          console.error(err);
          this.ionic.alert('GLOBAL.GENERAL_ERROR');
        });
      }
    })


  }

  loadUserInvites(uri: string = 'user_invites', filters: any = null, append: boolean = false): void {
    this.userInvitesView.loading = true;

    this.apiService.getCollection(uri, filters).then((apiResponse: ApiCollectionResponse) => {
      if(append) {
        this.allUserInvites = [...this.allUserInvites, ...apiResponse.items];
      }
      else {
        this.allUserInvites = apiResponse.items;
      }
      
      this.visibleUserInvites = this.allUserInvites;
      this.userInvitesView = apiResponse.view;
      this.userInvitesView.loading = false;

    }).catch((err) => {
      console.error(err);
      this.ionic.alert('GLOBAL.GENERAL_ERROR');
    });
  }

  removeUserInviteFromList(revokedUserInvite: UserInvite) {
    this.allUserInvites = this.allUserInvites.filter(userInvite => userInvite.fullName !== revokedUserInvite.fullName);
    this.visibleUserInvites = this.allUserInvites;
  }
  
  addUserInviteToList(userInvite: UserInvite) {
    this.allUserInvites.push(userInvite);
    this.visibleUserInvites = this.allUserInvites;
  }

  userInvitesSearch(): void {
    this.userInvitesView.loading = true;
    
    if(this.userInviteSearchTerm) {
      this.visibleUserInvites = this.allUserInvites.filter(userInvite => {
        const lowerCaseName = userInvite.fullName.toLowerCase();
        const lowerCaseSearchTerm = this.userInviteSearchTerm.toLowerCase();
        return lowerCaseName.includes(lowerCaseSearchTerm);
      });
    } else {
      this.visibleUserInvites = this.allUserInvites;
    }

    this.userInvitesView.loading = false;
  }
}



// WEBPACK FOOTER //
// ./src/components/admin-panel/admin-panel.ts